/**
 * Data formatting functions
 */
export default {
  /**
   * Format a number to price value
   * @param value {number} A number with thousands to format (ex. 10000)
   * @param digits {boolean} if true, show two digits
   * @returns {string} The formatted number (ex. 10.000,00)
   */
  number: (value, digits = true) => {
    const tmp = Math.abs(Number(value) || 0).toFixed(2).toString().split('.');
    const intVal = tmp[0];
    const j = (intVal.length > 3) ? intVal.length % 3 : 0;
    const intPart = `${(j ? `${intVal.substr(0, j)}.` : '')}${intVal.substr(j).replace(/(\d{3})(?=\d)/g, '$1.')}`;

    if (!digits) {
      return `${value < 0 ? '-' : ''}${intPart}`;
    }

    return `${value < 0 ? '-' : ''}${intPart},${tmp[1]}`;
  },
  /**
   * Format a thousand number, adding dot sep arator
   * @param number {number}   A number with thousands to format (ex. 10000)
   * @returns {string}        The formatted number (ex. 10.000)
   */
  thousand: (number, decimals = 2) => {
    let decimalCount = decimals;
    let amount = number;

    const thousands = '.';
    decimalCount = Math.abs(decimalCount);
    decimalCount = Number.isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount), 10).toString();
    const j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`);
  },
  /**
   * Convert a string to number and return a default value if is NaN
   */
  toNumber: (string, emptyValue = 0) => {
    const value = parseInt(string, 10);
    return Number.isNaN(value) ? emptyValue : value;
  },
};
